import { PaginatedRequestParams, PaginatedResponse } from "../../../../common/pagination";
import { PaymentOrderRepository } from "../../data";
import { PaymentOrder } from "../dtos";

export class PaymentorderService {

    private readonly repository;

    constructor() {
        this.repository = new PaymentOrderRepository();
    }

    public search(req: PaginatedRequestParams): Promise<PaginatedResponse<PaymentOrder>> {
        return this.repository.search(req);
    }


    /**
     * Get partner details by id
     * @param id
     */
    public getDetails(id: number): Promise<PaymentOrder> {
        return this.repository.getDetails(id);
    }

    public releaseAmount(id: number, otp: string): Promise<boolean> {
        return this.repository.releaseAmount(id, otp);
    }
    public cancel(id: number): Promise<boolean> {
        return this.repository.cancel(id);
    }
    // public deactivateAll(ids: number[]): Promise<boolean> {
    //     return this.repository.deactivateAll(ids);
    // }
}